// components/ui/Modal.jsx
import ReactDOM from "react-dom";

export default function Modal({
  open,
  onClose,
  children,
  panelClassName = "",
}) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center py-12 px-4"
      aria-modal="true"
      role="dialog"
    >
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-sm"
        onClick={onClose}
      />
      {/* card */}
      <div
        className={[
          "rounded-xl p-4 shadow-md bg-container flex flex-col gap-4 max-w-2xl w-fit relative max-h-full overflow-y-scroll",
          panelClassName,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
